<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="130px"
        v-loading="loading">

        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="deviceName" label="设备名称">
            {{ formData.deviceName||'--' }}
          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="location" label="安装位置">
              {{ formData.location||'--' }}

          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="status" label="当前状态">
              <el-tag type="success" v-if="formData.status == '1'">闲置</el-tag>
            <el-tag   v-if="formData.status == '2'">运行</el-tag>
            <el-tag type="danger" v-if="formData.status == '3'">维护</el-tag>

          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="deviceCode" label="设备代码">
              {{ formData.deviceCode||'--' }}

          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="manager" label="管理人">
              {{ formData.managerName||'--' }}

          </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'specialEquipmentDetail',

  data () {
    return {
      formData: {
        deviceName: '',
        location: '',
        deviceCode: '',
        status: '',
        manager: ''
      },

      loading: false

    }
  },
  created () {
    if (this.deviceId) {
      this.loadData()
    }
  },
  computed: {
    deviceId () {
      return this.$route.query.deviceId
    }

  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.specialEquipment.selectPaSpecialEquipmentByDeviceId, {
          params: { deviceId: this.deviceId }
        })
        .then(res => {
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }

  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

</style>
